import { defaultGetAction } from '../../utils';

import { GET_CHART_DATA } from './constants';

export const loadChartData = defaultGetAction(GET_CHART_DATA, 'graph_points');



// WEBPACK FOOTER //
// ./src/redux/Chart/actions.js